import './App.css';
import HeaderNavbar from './navbar';
import Alert from 'react-bootstrap/Alert';
import { useState } from 'react';
import { Container } from 'react-bootstrap';
import DropdownHierarchy from './customersTree';

function App() {
    const [show, setShow] = useState(true);

    return (
        <div>
            <HeaderNavbar />
            <br />
            <Container>
                <Alert variant="info" style={{ textAlign: "center" }}>
                    ℹ️Please come back after 5 minutes if you do not see any data in the dropdown below. This is because the Render free tier puts apps to sleep after 15 minutes of inactivity.{' '}
                </Alert>
            </Container>
            <DropdownHierarchy />
        </div>
    );
}


export default App;
